import * as React from "react";
import { Link } from "gatsby";

import { appStoreRating } from "../config/site";
import { useGuideLinks } from "../hooks/useGuideLinks";

// Plain-text statement of what the app is, who it is for and the proof, plus
// links to every guide. Lives in the repo, not Prismic, so the rating shown
// here and the rating in the structured data always come from one value.
const AppFacts = () => {
  const guides = useGuideLinks();

  return (
    <section className="container antialiased py-10 md:py-16 lg:py-24" id="about">
      <div className="lg:w-10/12 lg:ml-[8.333%] md:flex gap-10 lg:gap-20">
        <div className="md:w-7/12">
          <h2 className="text-3xl lg:text-4xl font-medium mb-6">
            What Schengen Simple is
          </h2>
          <p className="text-lg lg:text-xl text-charcoal mb-4">
            Schengen Simple is an app for iPhone and Android that keeps track
            of the Schengen 90/180-day rule. Add the trips you have taken and
            the trips you are planning, and it shows how many days you have
            left and how long you could stay from any date in the calendar.
          </p>
          <p className="text-lg lg:text-xl text-charcoal mb-4">
            It is made for people who visit the Schengen area often: owners of
            second homes, motorhome and long-stay travellers, people who travel
            for work, and anyone who splits the year between home and Europe.
          </p>
          <p className="text-lg lg:text-xl text-charcoal">
            Rated {appStoreRating.value} out of 5 from{" "}
            {appStoreRating.displayCount} ratings on the UK App Store. Plans
            cover one, two or up to five travellers.
          </p>
        </div>
        <div className="md:w-5/12 mt-10 md:mt-0">
          <h2 className="text-3xl lg:text-4xl font-medium mb-6">
            Guides to the rules
          </h2>
          <ul className="text-lg text-charcoal">
            {guides.map((guide) => (
              <li className="mb-2" key={guide.slug}>
                <Link
                  to={`/${guide.slug}/`}
                  className="underline hover:text-teal"
                >
                  {guide.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default AppFacts;
